import { accordion } from './accordion/accordion';

export function init() {
	const inst = accordion('ccba', {
		activeHeaderClass: 'is-active',
		activePanelClass: 'is-active',
		multiselect: false,
	});

	if (inst) {
		inst.init();
	}
}
